import { reactive, ref, onMounted, onUnmounted, nextTick } from 'vue'

export function useFloatingTooltip() {
  const floatingTooltip = reactive({
    visible: false,
    text: '',
    left: 0,
    top: 0
  })

  const lastTarget = ref(null)

  const gap = ref(8) // default gap between the icon top and tooltip bottom in px

  function computePositionFromElement(el) {
    if (!el) return
    const rect = el.getBoundingClientRect()
    floatingTooltip.left = Math.round(rect.left + rect.width / 2)
    // initial fallback top - will be corrected after measuring tooltip height
    floatingTooltip.top = Math.round(rect.top - gap.value)
  }

  async function showFloatingTooltip(e, text, customGap = null) {
    const el = e.currentTarget || e.target
    if (!el) return
    lastTarget.value = el
    if (customGap !== null) gap.value = customGap
    computePositionFromElement(el)
    floatingTooltip.text = text
    floatingTooltip.visible = true
    // wait for DOM, then measure tooltip height and set exact top so tooltip bottom is gap px above el.top
    await nextTick()
    const tooltipEl = document.querySelector('.floating-tooltip')
    if (tooltipEl && el) {
      const tooltipRect = tooltipEl.getBoundingClientRect()
      const elRect = el.getBoundingClientRect()
      floatingTooltip.left = Math.round(elRect.left + elRect.width / 2)
      floatingTooltip.top = Math.round(elRect.top - tooltipRect.height - gap.value)
    }
  }

  function hideFloatingTooltip() {
    floatingTooltip.visible = false
    lastTarget.value = null
  }

  async function updatePosition() {
    if (!lastTarget.value || !floatingTooltip.visible) return
    computePositionFromElement(lastTarget.value)
    await nextTick()
    const tooltipEl = document.querySelector('.floating-tooltip')
    if (tooltipEl && lastTarget.value) {
      const tooltipRect = tooltipEl.getBoundingClientRect()
      const elRect = lastTarget.value.getBoundingClientRect()
      floatingTooltip.left = Math.round(elRect.left + elRect.width / 2)
      floatingTooltip.top = Math.round(elRect.top - tooltipRect.height - gap.value)
    }
  }

  onMounted(() => {
    window.addEventListener('scroll', updatePosition, true)
    window.addEventListener('resize', updatePosition)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', updatePosition, true)
    window.removeEventListener('resize', updatePosition)
  })

  return { floatingTooltip, showFloatingTooltip, hideFloatingTooltip, updatePosition, gap }
}
